export class RepReportCountryEntity{

    id:number;
    countryId:number;
    reportId:number;

    constructor(){}
}